// extracted by mini-css-extract-plugin
var _1 = "InfiniteScrollWaypoint-module__loader--iB1uX";
export { _1 as "loader" }
